import { Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { CategoryService } from '../../../services/category.service';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { CategoryPublicDTO } from '../../../model/category-dto';
import { trigger, style, animate, transition } from '@angular/animations';

interface FAQ {
  question: string;
  answer: string;
  open?: boolean;
}

@Component({
  selector: 'app-landing-content',
  standalone: true,
  imports: [
    MatIconModule,
    CommonModule,
    MatButtonModule
  ],
  templateUrl: './landing-content.component.html',
  styleUrl: './landing-content.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  animations: [
    trigger('expandCollapse', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(-12px)' }),
        animate('280ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ opacity: 0, transform: 'translateY(-12px)' }))
      ])
    ])
  ]
})
export class LandingContentComponent implements OnInit {

  @ViewChild('searchInput') searchInput!: ElementRef;

  categories: CategoryPublicDTO[] = [];
  selectedCategory: CategoryPublicDTO | null = null;

  quickSearches = [
    'Aseo y Limpieza',
    'Plomería y Mantenimiento',
    'Belleza y Estética',
    'Cuidado de Mascotas',
    'Tutorías y Clases'
  ];

  howItWorksSteps = [
    {
      step: '01',
      icon: 'search',
      title: 'Busca lo que necesitas',
      description: 'Explora nuestras categorías o busca el servicio exacto que requieres para tu hogar o empresa.'
    },
    {
      step: '02',
      icon: 'badge',
      title: 'Conecta con Expertos Verificados',
      description: 'Recibe asistencia de profesionales calificados (Workbies) previamente validados por nuestro equipo.'
    },
    {
      step: '03',
      icon: 'verified_user',
      title: 'Pago Seguro con ePayco',
      description: 'Realiza tus pagos de forma protegida a través de pasarelas de pago cifradas y transacciones en línea.'
    },
    {
      step: '04',
      icon: 'star',
      title: 'Disfruta y Califica',
      description: 'Recibe un servicio de alta calidad, califica tu experiencia y ayuda a construir una comunidad confiable.'
    }
  ];

  trustFeatures = [
    {
      icon: 'shield',
      title: 'Seguridad y Verificación',
      description: 'Validamos identidades y antecedentes de nuestros Workbies para tu absoluta tranquilidad.'
    },
    {
      icon: 'lock',
      title: 'Pagos 100% Protegidos',
      description: 'Transacciones seguras procesadas con infraestructura Fintech y pasarela ePayco.'
    },
    {
      icon: 'bolt',
      title: 'Respuesta Inmediata',
      description: 'Encuentra especialistas disponibles rápidamente, justo cuando los necesitas.'
    },
    {
      icon: 'thumb_up',
      title: 'Garantía de Satisfacción',
      description: 'Calificaciones transparentes y soporte continuo a través de nuestros canales de atención.'
    }
  ];

  faqs: FAQ[] = [
    {
      question: '¿Qué es Workbi y cómo me ayuda?',
      answer: 'Workbi es una plataforma tecnológica que te conecta con profesionales confiables (Workbies) para solucionar necesidades del hogar, mantenimiento, belleza, tecnología y mucho más.',
      open: false
    },
    {
      question: '¿Cómo garantizan la seguridad de los servicios?',
      answer: 'Todos los prestadores (Workbies) registrados pasan por un proceso estricto de verificación de identidad y antecedentes antes de ser habilitados en la plataforma.',
      open: false
    },
    {
      question: '¿Qué medios de pago puedo utilizar?',
      answer: 'Contamos con integración segura mediante ePayco, permitiéndote pagar con tarjetas de crédito, PSE, transferencias y otros métodos de pago electrónicos respaldados.',
      open: false
    },
    {
      question: '¿Cómo puedo ofrecer mis servicios como Workbie?',
      answer: 'Si eres un profesional o especialista, puedes registrarte en la aplicación de Workbi, completar tu perfil con tus habilidades y empezar a recibir solicitudes de clientes.',
      open: false
    }
  ];

  constructor(
    private service: CategoryService,
    private spinner: SpinnerVisibilityService
  ) { }

  ngOnInit(): void {
    this.getPublicCategories();
  }

  getPublicCategories() {
    this.spinner.show();
    this.service.getPublicCategories().subscribe({
      next: (resp) => {
        this.categories = resp.data.categories ?? [];
        this.spinner.hide();
      },
      error: (err) => {
        console.error(err);
        this.spinner.hide();
      }
    });
  }

  toggleCategory(cat: CategoryPublicDTO) {
    if (this.selectedCategory?.categoryId === cat.categoryId) {
      this.selectedCategory = null;
    } else {
      this.selectedCategory = cat;
    }
  }

  toggleFaq(index: number) {
    this.faqs[index].open = !this.faqs[index].open;
  }

  onFocus() {
    setTimeout(() => {
      this.searchInput.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 100);
  }

}
